import React from 'react';
import PropTypes from 'prop-types';
import './VenueMarketingOptIn.scss';

import { CheckboxSwitch, CheckboxGroup, TranslationProvider } from '@resy/ui-kitchen';

const VenueMarketingOptIn = ({ checked, onChange, venueInfo }) => {
  const marketingOptInText = 'You consent to receive offers and marketing from this restaurant. You can withdraw consent at any time with the restaurant.';
  const {
    contact: {
      phone = {},
    } = {},
    location: {
      address1,
      address2,
      city,
      state,
      postalCode,
    } = {},
    name,
  } = venueInfo;

  const phoneNumber = phone?.phoneLabel;

  const getVenueAddress = () => (
    <p>{address2 ? `${address1}, ${address2}, ${city}, ${state} ${postalCode}` : `${address1}, ${city}, ${state} ${postalCode}`}</p>
  );
  return (
    <div className="VenueMarketingOptIn">
      <label htmlFor="venue_marketing_opt_in">
        <CheckboxGroup>
          <CheckboxSwitch
            data-test-id="order_summary_page-checkbox-venue_opt_in"
            name="venue_marketing_opt_in"
            on={checked}
            onClick={onChange}
          />
          <TranslationProvider
            translationKey="venue_communication_opt_in"
          >
            <div className="VenueMarketingOptIn__text">
              {marketingOptInText}
            </div>
          </TranslationProvider>
        </CheckboxGroup>
      </label>
      {
        checked
        && (
        <div className="VenueMarketingOptIn__venue-info">
          <strong>{name}</strong>
          <div className="VenueMarketingOptIn__venue-address">{getVenueAddress()}</div>
          {phoneNumber && phoneNumber}
        </div>
        )
      }
    </div>
  );
};

VenueMarketingOptIn.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  venueInfo: PropTypes.shape({
    contact: PropTypes.shape({
      phone: PropTypes.shape({
        phoneUrl: PropTypes.string,
      }),
    }),
    location: PropTypes.shape({
      address1: PropTypes.string,
    }),
    name: PropTypes.string,
  }),
};

VenueMarketingOptIn.defaultProps = {
  checked: false,
  venueInfo: undefined,
};

export default VenueMarketingOptIn;
